// Freeze both geometry and camera on the inactive side. Each 30-second cycle
// has 12 seconds of training, a pause, 15 seconds of ARC, then another pause.
export function homeClocks(seconds) {
    const cycle = Math.floor(seconds / 30);
    const phase = seconds % 30;
    const arcProgress = Math.max(0, Math.min(15, phase - 13));
    return {
        training: (cycle * 12 + Math.min(12, phase)) * .55,
        arcCamera: (cycle * 15 + arcProgress) * .42,
        arcArrival: phase < 13 ? 6.3 : arcProgress * .42,
    };
}

// Never advance while hidden, offscreen or printing. Reduced motion
// starts with a complete, static drawing.
export function animateMasthead(hero, draw, layout) {
    const abort = new AbortController();
    const options = {signal: abort.signal};
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const mobile = matchMedia('(max-width: 700px)');
    const print = matchMedia('print');
    let visible = true, disposed = false;
    let frame = 0, previous = null, elapsed = 0;
    const render = () => draw(elapsed / 1000, mobile.matches, reduced.matches);
    function tick(time) {
        if (disposed) return;
        if (previous !== null) elapsed += Math.min(time - previous, 80);
        previous = time;
        render();
        frame = requestAnimationFrame(tick);
    }
    function playback() {
        cancelAnimationFrame(frame);
        frame = 0;
        previous = null;
        if (!disposed && !reduced.matches && visible && !document.hidden && !print.matches) frame = requestAnimationFrame(tick);
    }
    function resize() { layout(mobile.matches); render(); }
    reduced.addEventListener('change', () => { render(); playback(); }, options);
    mobile.addEventListener('change', resize, options);
    print.addEventListener('change', playback, options);
    document.addEventListener('visibilitychange', playback, options);
    const observer = new IntersectionObserver(([entry]) => { visible = entry.isIntersecting; playback(); });
    observer.observe(hero);
    resize();
    playback();
    return () => { disposed = true; abort.abort(); cancelAnimationFrame(frame); observer.disconnect(); };
}
